import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RawOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"raw_off"}/>
}
